import { observable } from 'mobx';

const portalModel = observable({
    content: null,
    title: null
});

export default portalModel;